import React from "react";
import { Form } from "react-bootstrap";

const PhoneNumberObt = (props) => {
  return (
    <Form.Group>
      <Form.Label>{props.name}</Form.Label>
      <Form.Control type="phone" placeholder={"Enter " + props.name} />
    </Form.Group>
  );
};

export default PhoneNumberObt;
